import type { KeycloakTokenParsed } from 'keycloak-js';
import { isObject, isString } from 'lodash-es';

export type UserIdToken = KeycloakTokenParsed & {
  activeOrganization: CurrentOrganisation;
  iss: string;
  preferred_username: string;
};

export type Organisations_Role = Record<string, {
    name: string;
    roles: string[];
  }>;

export type CurrentOrganisation = {
  name: string;
  role: string[];
  id: string;
  attribute: Record<string, string[]>;
};

export const isUserIdToken = (idToken: unknown | undefined): idToken is UserIdToken => {
  return (
    isObject(idToken) &&
    isString((idToken as UserIdToken)['iss']) &&
    isString((idToken as UserIdToken)['preferred_username']) &&
    isObject((idToken as UserIdToken)['activeOrganization'])
  );
};

export function getUserIdToken(idToken: unknown | undefined): UserIdToken {
  if (!isUserIdToken(idToken)) {
    throw new Error(`Organisation data missing from ID token: ${JSON.stringify(idToken)}`);
  }

  return idToken;
}
